//INDEX
export const DIALOGINDEXALERT = 300000
export const DIALOGINDEXPERIOD = 800
export const EXPIRED_MESSAGE_NOT_SHOW = 24 * 60 * 60 * 1000

//CHATPAGE
export const CONTACTAGENT = 5000

export const PWAALERT = 7 * 24 * 60 * 60 * 1000
// multipage
export const COUNTDOWNONESEC = 1000
export const DELAYREDIRECTPAGE = 2500

// DEPOSIT & WITHDRAW PAGE
export const COPYACCOUNTWITHDRAW = 1500
export const COPYACCOUNTTOPUP = 1500
export const REGISTEROTPREQUEST = 15 //sec  
export const CHANGEPASSWORDOTPVERIFY = 15//sec
export const CHANGEPASSWORDOTPREQUEST = 15 //sec  

//GAME LOTTO 
export const CLOSEGAMEBEFORE = 5000 // multi
export const DEBOUNCEFETCHGAME = 5000
export const DEBOUNCBUTTON = 300 // multi

//GAME PAGE
export const DELAYDIGITALPIN = 500
export const FETCHRESULTGAME = 10000
export const RESULTLISTGAMETABDELAY = 100

//appbar
export const FETCHMARQUEE = 300000
export const FETCHCREDIT = 10000


//externalgame 

export const FETCHCHECKFOCUS = 300
export const FETCHCHECKALIVE = 10000



//power ball 
export const FETCH_POWERBALL = 10000







